import * as types from "../actions/types";


const initialState = null;


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CONFIGURATIONS_COMPLETED:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};
